import { useEffect, useState } from 'react';

const useMobileDevice = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(window.innerWidth < 744);
  }, []);

  return { isMobileDevice };
};

export default useMobileDevice;
